import { render, staticRenderFns } from "./ArquivoFiscal.vue?vue&type=template&id=2af5a221&"
import script from "./ArquivoFiscal.vue?vue&type=script&lang=js&"
export * from "./ArquivoFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports